module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B2WKH7F.328bd829.jpg";